<!-- =========================================================================================
    File Name: V2Header.vue
    Description: .
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <header id="v2_page_header" class="v2_header_container">
    <div class="v2_header_content">
      <template v-if="isMobile">
        <button class="v2_header_sidebar_btn" @click="toggleSidebar">
          <vs-icon
            class="text-2xl"
            icon-pack="feather"
            icon="icon-menu"
            color="white"
          ></vs-icon>
        </button>
      </template>
      <template v-else>
        <img :src="companyLogo" alt="Logo da Empresa" class="v2_header_img" />
      </template>

      <div class="v2_header_profile">
        <v2-header-notifications />

        <div class="v2_header_profile_user">
          <p v-if="!isMobile" class="v2_header_profile_user_name">
            Olá, {{ username }}
          </p>

          <v2-header-actions />
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import V2HeaderActions from './V2HeaderActions.vue';

import V2HeaderNotifications from './V2HeaderNotifications.vue';

export default {
  props: {
    isMobile: {
      type: Boolean,
      required: true,
    },
    isSidebarOpen: {
      type: Boolean,
      required: true,
    },
    companyLogo: {
      type: String,
      required: true,
    },
    toggleSidebar: {
      type: Function,
      required: true,
    },
  },

  components: {
    V2HeaderActions,
    V2HeaderNotifications,
  },

  computed: {
    username: {
      get() {
        return this.$store.state.nomeCurrentUsuario;
      },
    },
  },
};
</script>

<style lang="scss">
.v2_header_container {
  height: 64px;
  width: 100%;
  background-color: #082440;
  padding: 8px 24px 8px 24px;

  @media (max-width: 768px) {
    height: 48px;
    padding: 12px 16px 12px 16px;
  }
}

.v2_header_content {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.v2_header_img {
  height: 100%;
  max-width: 200px;
  object-fit: contain;
}

.v2_header_sidebar_btn {
  background-color: transparent;
  outline: transparent;
  border: 0;
  cursor: pointer;
}

.v2_header_profile {
  display: flex;
  align-items: center;
}

.v2_header_profile_user {
  display: flex;
  align-items: center;
  border-left: 1px solid #ffffff;
  gap: 12px;

  @media (max-width: 768px) {
    border: 0;
  }
}

.v2_header_profile_user_name {
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  margin-left: 12px;
}
</style>
